module.exports = __webpack_public_path__ + "static/media/snx.4cb4ec3b.svg";